import { z } from 'zod';

export const feeSchema = z.object({
    name: z.string().min(1, 'Name is required').max(50),
    transaction_type_id: z.string().uuid('Transaction type is required'),
});

export type FeeFormInput = z.input<typeof feeSchema>;
export type FeeFormOutput = z.output<typeof feeSchema>;
